module.exports = __webpack_public_path__ + "img/Group 590.8186c6ac.png";